export default __webpack_public_path__ + "static/media/ant-design_facebook-filled.e94f6500.svg";